<div *ngIf="loading; else showPlaceholder" class="select-placeholder-container">
  <span>{{ loadingPlaceholder }}</span>
  <mat-spinner class="spinner" diameter="16" />
</div>

<ng-template #showPlaceholder>{{ placeholder }}</ng-template>
